import { IconProps } from '.'

export function WidthIcon({
  width = 18,
  height = 14,
  color = '#536063',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 14'
      focusable='false'
      role='img'
      aria-hidden
      {...props}
      fill='none'
    >
      <path
        d='M15.6667 12.8334V1.16675C15.6667 0.708415 16.0417 0.333415 16.5 0.333415C16.9583 0.333415 17.3333 0.708415 17.3333 1.16675V12.8334C17.3333 13.2917 16.9583 13.6667 16.5 13.6667C16.0417 13.6667 15.6667 13.2917 15.6667 12.8334ZM0.666664 12.8334L0.666664 1.16675C0.666664 0.708415 1.04166 0.333415 1.5 0.333415C1.95833 0.333415 2.33333 0.708415 2.33333 1.16675L2.33333 12.8334C2.33333 13.2917 1.95833 13.6667 1.5 13.6667C1.04166 13.6667 0.666664 13.2917 0.666664 12.8334ZM6.5 6.16675V4.67508C6.5 4.30008 6.05 4.11675 5.79166 4.38341L3.46666 6.70841C3.3 6.87508 3.3 7.13341 3.46666 7.30008L5.79166 9.62508C6.05 9.88341 6.5 9.70008 6.5 9.32508V7.83342L11.5 7.83342V9.32508C11.5 9.70008 11.95 9.88341 12.2083 9.61675L14.5333 7.29175C14.7 7.12508 14.7 6.86675 14.5333 6.70008L12.2083 4.37508C11.95 4.11675 11.5 4.30008 11.5 4.66675V6.16675L6.5 6.16675Z'
        fill={color}
      />
    </svg>
  )
}
